import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { friendApi, memberSummaryApi } from '@formosa/shared/api/im';
import '../../styles/chat.css';

export default function FriendRequestsPage() {
  const [direction, setDirection] = useState('incoming');
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');
  const [summaries, setSummaries] = useState({});

  const load = useCallback(() => {
    setError('');
    friendApi
      .listRequests(direction)
      .then(async (data) => {
        const list = Array.isArray(data) ? data : data?.data || [];
        setItems(list);
        const ids = list.map((r) =>
          direction === 'incoming' ? r.fromMemberId : r.toMemberId
        );
        if (!ids.length) {
          setSummaries({});
          return;
        }
        try {
          const sum = await memberSummaryApi.batch(ids);
          const map = {};
          (sum || []).forEach((s) => {
            if (s?.memberId != null) map[s.memberId] = s;
          });
          setSummaries(map);
        } catch {
          setSummaries({});
        }
      })
      .catch((e) => setError(e?.message || '載入失敗'));
  }, [direction]);

  useEffect(() => {
    load();
  }, [load]);

  const act = async (fn) => {
    try {
      await fn();
      load();
    } catch (e) {
      setError(e?.message || '操作失敗');
    }
  };

  return (
    <div className="chat-social-page">
      <header className="chat-social-page__header">
        <Link to="/chat/contacts" className="chat-link-btn">
          ← 聯絡人
        </Link>
        <h1>好友邀請</h1>
        <div className="chat-social-page__actions">
          <button
            type="button"
            className={direction === 'incoming' ? 'is-active' : ''}
            onClick={() => setDirection('incoming')}
          >
            收到
          </button>
          <button
            type="button"
            className={direction === 'outgoing' ? 'is-active' : ''}
            onClick={() => setDirection('outgoing')}
          >
            已送出
          </button>
        </div>
      </header>
      {error ? <p className="chat-social-page__error">{error}</p> : null}
      <ul className="chat-social-page__list">
        {items.map((r) => {
          const peerId = direction === 'incoming' ? r.fromMemberId : r.toMemberId;
          const s = summaries[peerId];
          const name = s?.displayName || s?.username || `會員 ${peerId}`;
          return (
            <li key={r.id}>
              <div className="chat-social-page__row">
                <span className="chat-social-page__name">{name}</span>
                {r.message ? <span className="chat-social-page__meta">{r.message}</span> : null}
              </div>
              {direction === 'incoming' ? (
                <>
                  <button type="button" className="chat-link-btn" onClick={() => act(() => friendApi.accept(r.id))}>
                    接受
                  </button>
                  <button type="button" className="chat-link-btn" onClick={() => act(() => friendApi.reject(r.id))}>
                    拒絕
                  </button>
                </>
              ) : (
                <button type="button" className="chat-link-btn" onClick={() => act(() => friendApi.cancel(r.id))}>
                  取消
                </button>
              )}
            </li>
          );
        })}
      </ul>
      {!items.length ? <p className="chat-social-page__empty">沒有邀請</p> : null}
    </div>
  );
}
